import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import {
  Navbar,
  NavbarBrand,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarText,
} from "reactstrap";
import logo from "../../images/logo.png";
import Swal from "sweetalert2";
import { logout } from "../../functions/CoreFunctions";
import ProfileAvatar from "../../constants/Images/defaultAvatar-1.png";

import { useSelector } from "react-redux";
export default function Header() {
  const history = useNavigate();

  let Signout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to sign out",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sign Out",
    }).then((result) => {
      if (result.isConfirmed) {
        logout(history);
      }
    });
  };

  const [name, setName] = useState();
  const [lname, setlName] = useState();
  const [profileimage, setProfile] = useState();
  const reduxState = useSelector((state) => state.AuthUserDetailsReducer);

  useEffect(() => {
    const {
      firstName,
      lastName,

      profileImage = "",
    } = reduxState;

    setName(firstName);
    setlName(lastName);
    setProfile(profileImage);
  }, [reduxState]);
  let Profile = () => {
    const image = profileimage;
    if (image) {
      return image;
    } else {
      return ProfileAvatar;
    }
  };
  return (
    <Fragment>
      <Navbar color="white" light expand="md" sticky="top">
        <NavbarBrand>
          <span className="menubar">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path d="M442 114H6a6 6 0 0 1-6-6V84a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6z" />
            </svg>
          </span>
          <img src={logo} alt="Logo" />
        </NavbarBrand>

        <NavbarText className="ml-auto navbar-profile">
          <UncontrolledDropdown setActiveFromChild>
            <DropdownToggle tag="a">
              {name} {lname}
              {""}
              <img alt="Profile" src={Profile()} />
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={Signout}>
                <svg
                  className="adminSignOutBtn"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path d="M48 64h132c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H48c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h132c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48zm279 19.5l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l132 131.4H172c-6.6 0-12 5.4-12 12v10c0 6.6 5.4 12 12 12h279.9L320 404.4c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0l164.5-164c4.7-4.7 4.7-12.3 0-17L344 83.5c-4.7-4.7-12.3-4.7-17 0z" />
                </svg>{" "}
                Sign Out
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </NavbarText>
      </Navbar>
    </Fragment>
  );
}
